import AppConfig from '@/config'

declare const window: Window

/**
 * Единственная точка ухода на внешний сервис авторизации.
 * В internal-режиме редиректов нет вообще: возвращаем false, и вызывающий код
 * сам решает, что делать (остаться на месте / уйти на '/').
 * @returns true, если браузер уходит по replace.
 */
export function redirectToAuth(): boolean {
	if (AppConfig.authMode === 'internal') return false
	window.location.replace(AppConfig.authRedirectUrl)
	return true
}
